import { TranslatedString } from "./translated-string"

export interface Workspace {
    id: string,
    workspaceId?: string | null,
    name: TranslatedString,
    type: string,
}

export interface WorkspaceResource {
    id?: string | null
    workspaceId?: string | null 
    type?: string | null 
    name?: TranslatedString | null 
}

export enum WorkspaceType {
    museum = "museum",
    archive = "archive",
    specimen = "specimen"
}